import SeoHead from '../components/SeoHead'
import Hero from '../components/Hero'
import Features from '../components/Features'
import FAQ from '../components/FAQ'
import { useLanguage } from '../i18n/LanguageContext'

const HomePage = () => {
  const { t } = useLanguage()
  const faqItems = t('faq.items', { returnObjects: true }) as Array<{ question: string; answer: string }>
  const description = t('seo.homeDescription')
  const title = t('seo.homeTitle')
  const structuredData = [
    {
      '@context': 'https://schema.org',
      '@type': 'SoftwareApplication',
      name: 'SheetMate',
      applicationCategory: 'BrowserApplication',
      operatingSystem: 'Chrome',
      description,
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD'
      },
      url: 'https://sheetmate-452111.web.app/'
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    }
  ]

  return (
    <>
      <SeoHead
        title={title}
        description={description}
        path="/"
        keywords={['Google Sheets preview', 'Markdown preview', 'JSON viewer', 'LaTeX', 'Chrome extension']}
        structuredData={structuredData}
      />
      <Hero />
      <Features />
      <FAQ />
    </>
  )
}

export default HomePage
